import React, { useEffect, useRef } from 'react';
import NavLink from 'ui-components/NavLink';
import xClass from 'utils/xClass';
import useInvisibler from 'decorators/Invisibler';
import {
	AUTO_TIME,
	TIME_BEFORE_UI_FADES,
	ROUTES
} from 'constants';
// import RoutePreloader from 'components/RoutePreloader';
// Nav components
import HourGlass from 'components/nav/HourGlass';
import NavArrows from 'components/nav/NavArrows';
import AdditionsLink from 'components/nav/AdditionsLink';
import ThumbsLink from 'components/nav/ThumbsLink';
import ThanksLink from 'components/nav/ThanksLink';
import IndexLink from 'components/nav/IndexLink';
import AboutLink from 'components/nav/AboutLink';

const Nav = ({ toggleAuto, auto, next, previous, mouseSide, id, pathname, work }) => {
	const invisible = useInvisibler({ delay: TIME_BEFORE_UI_FADES });
	const autoTimerRef = useRef(null);

	useEffect(() => {
		if (auto) {
			clearInterval(autoTimerRef.current);
			autoTimerRef.current = setInterval(() => {
				if (auto && work.type !== 'video') {
					next();
				} else {
					clearInterval(autoTimerRef.current);
				}
			}, AUTO_TIME);
		} else {
			clearInterval(autoTimerRef.current);
		}

		return () => {
			clearInterval(autoTimerRef.current);
		};
	}, [auto, id, work, next]);

	const onClick = (e) => {
		e.stopPropagation();
	};

	return pathname !== "/" && (
		<nav
			id="navigation"
			className={xClass({invisible})}
			onClick={onClick}
		>
			<IndexLink/>
			<ThumbsLink/>
			<AboutLink/>
			<ThanksLink/>
			<AdditionsLink/>
			<HourGlass
				id={id}
				on={auto}
				onClick={toggleAuto}
				totalTime={AUTO_TIME}
			/>
			<NavArrows
				next={next}
				previous={previous}
				mouseSide={mouseSide}
			/>
		</nav>
	);
};

export default Nav;


